import React, { Component } from 'react';
import {
    FormGroup,
    Col,
    FormControl,
    ControlLabel
} from 'react-bootstrap';
import axios from 'axios';

module.exports = class CountrySelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            options: null,
            value: ''
        };

        this.selected = '';

    };

    changeValue(val) {
        this.selected = val;


        if (this.props.status == 'edit' || this.props.status == 'new') {
            var element = document.getElementById('country');
            element.value = val;
        }
        else {
            var all = this.state.options;
            if (all) {
                for (var i = 0; i < all.length; i++) {
                    if (all[i].props.value == val) {
                        this.setState({ value: all[i].props.children });
                        break;
                    }
                }
            }
        }
    }

    componentDidMount() {
        axios
            .get('/data/getCountries')
            .then(function (data) {
                /* this
                     ._loading
                     .Hide();*/

                var options = data.data.map(function (obj) {
                    return <option value={obj.ID} key={obj.ID}>{obj.Value}</option>;
                });

                if (this.selected != '') {
                    this.changeValue(this.selected);
                }

                this.setState({ options: options });
            }.bind(this))
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    };

    render() {
        var input;
        if (this.props.status == 'edit' || this.props.status == 'new') {
            input = <FormControl id="country" name="country" componentClass="select">
                {this.state.options}
            </FormControl>
        }
        else {
            input = <label>{this.state.value}</label>
        }

        return (
            <FormGroup >
                <Col componentClass={ControlLabel} lg={2}>
                    {this.props.caption}
                </Col>
                <Col lg={10}>
                    {input}
                </Col>
            </FormGroup >
        )
    }
}



// WEBPACK FOOTER //
// ./modules/register/CountrySelect.jsx